/** Parse admin sync API responses into UI-friendly status. */

export function bandFromPct(pct) {
  if (pct >= 80) return 'ok';
  if (pct >= 40) return 'warn';
  return 'bad';
}

export function bandClass(band) {
  if (band === 'ok') return 'bg-green-50 border-green-200 text-green-900';
  if (band === 'warn') return 'bg-amber-50 border-amber-200 text-amber-900';
  return 'bg-red-50 border-red-200 text-red-900';
}

export function parseActionResult(label, res, err) {
  if (err) {
    return {
      label,
      ok: false,
      partial: false,
      lines: [err],
      warnings: [],
      raw: null,
    };
  }
  const warnings = res?.warnings || [];
  const lines = [];
  let ok = res?.success !== false;
  let partial = warnings.length > 0;

  const s = res?.summary || {};

  if (label.includes('Warm T1') || label === 'Warm T1') {
    lines.push(`Fare routes refreshed: ${s.fare_routes_refreshed ?? res?.fares?.routes_refreshed ?? '—'}`);
    lines.push(`Fare rows updated: ${s.fare_rows_updated ?? res?.fares?.fare_rows_updated ?? '—'}`);
    lines.push(`Airline routes: ${s.airline_routes_updated ?? res?.airlines?.routes_with_airlines ?? '—'}`);
    lines.push(`Baggage routes: ${s.baggage_routes_updated ?? res?.baggage?.routes_updated ?? '—'}`);
    lines.push(`Visa synced: ${s.visa_synced ?? res?.visa?.ok ?? '—'}`);
    const fareRows = s.fare_rows_updated ?? res?.fares?.fare_rows_updated ?? 0;
    const routesRef = s.fare_routes_refreshed ?? res?.fares?.routes_refreshed ?? 0;
    if (routesRef === 0) {
      partial = true;
      ok = false;
    } else if (fareRows < Math.max(20, routesRef * 2)) {
      partial = true;
      ok = false;
    }
    if ((res?.visa?.error ?? 0) > 0) partial = true;
  } else if (label.includes('Fares T')) {
    lines.push(`Routes refreshed: ${s.routes_refreshed ?? res?.routes_refreshed ?? 0}`);
    lines.push(`Fare rows updated: ${s.fare_rows_updated ?? res?.fare_rows_updated ?? 0}`);
    if (res?.missing_pairs?.length) {
      lines.push(`Missing route entities: ${res.missing_pairs.length}`);
      partial = true;
    }
    const fr = res?.fare_rows_updated ?? s.fare_rows_updated ?? 0;
    const rr = res?.routes_refreshed ?? s.routes_refreshed ?? 0;
    if (rr === 0) ok = false;
    else if (fr < Math.max(10, rr * 2)) {
      partial = true;
      ok = false;
    }
  } else if (label.includes('Baggage')) {
    lines.push(`Routes updated: ${res?.routes_updated ?? 0}`);
    if ((res?.routes_updated ?? 0) === 0) partial = true;
  } else if (label.includes('Airlines') || label === 'Route airlines') {
    lines.push(`Routes processed: ${res?.routes_processed ?? 0}`);
    lines.push(`With airlines: ${res?.routes_with_airlines ?? 0}`);
    if ((res?.routes_with_airlines ?? 0) === 0 && (res?.routes_processed ?? 0) > 0) partial = true;
  } else if (label.includes('Logostream')) {
    const ap = res?.airports || {};
    const al = res?.airlines || {};
    const rt = res?.routes || {};
    lines.push(`Airports ok/error: ${ap.ok ?? '—'}/${ap.error ?? '—'}`);
    lines.push(`Airlines ok/error: ${al.ok ?? '—'}/${al.error ?? '—'}`);
    lines.push(`Routes batch: ${rt.routes ?? rt.ok ?? '—'}`);
  } else if (label.includes('Visa')) {
    lines.push(`Synced: ${res?.ok ?? res?.synced ?? '—'}`);
    lines.push(`Errors: ${res?.error ?? 0}`);
    if (res?.failed_destinations?.length) {
      lines.push(`Failed destinations: ${res.failed_destinations.join(', ')}`);
      partial = true;
    }
  } else if (label.includes('Apply tiers') || label.includes('Bootstrap')) {
    if (res?.tier_stats) {
      const t = res.tier_stats.tiers || res.tier_stats;
      lines.push(`Tier apply: ${JSON.stringify(t)}`);
    } else if (res?.tiers) {
      lines.push(`Tiers: ${JSON.stringify(res.tiers)}`);
    }
    if (res?.routes) lines.push(`Routes seed: ${JSON.stringify(res.routes)}`);
  } else if (label.includes('Bulk approve')) {
    const sum = res?.summary || res;
    lines.push(`Approved: ${sum?.approved ?? res?.approved_count ?? 0}`);
    lines.push(`Failed: ${sum?.failed ?? res?.failed_count ?? 0}`);
    if ((sum?.failed ?? 0) > 0) partial = true;
  } else if (label.includes('Generate')) {
    lines.push(`Generated: ${JSON.stringify(res?.generated || {})}`);
  } else if (label.includes('Country Logostream')) {
    lines.push(`OK: ${res?.ok ?? '—'}, skipped: ${res?.skipped ?? '—'}, errors: ${res?.error ?? '—'}`);
  } else {
    lines.push('Completed — see raw JSON for details.');
  }

  warnings.forEach((w) => lines.push(`⚠ ${w}`));

  return { label, ok: ok && !partial ? true : partial ? null : false, partial, lines, warnings, raw: res };
}
